import React from "react";
import { FiInfo } from "react-icons/fi";
import { UncontrolledTooltip } from "reactstrap";
import "./infoTooltip.scss";

/**
 * Ikon "i" dengan penjelasan singkat saat di-hover.
 *
 * `id` wajib diisi dan unik dalam satu halaman: reactstrap mencari target-nya
 * lewat selektor CSS, jadi pakai id yang diawali huruf dan hanya berisi
 * huruf/angka/tanda hubung.
 */
const InfoTooltip = ({ id, text, placement = "top" }) => (
  <>
    <FiInfo
      id={id}
      className="info-tooltip-icon"
      // Ikon bisa berada di dalam elemen yang punya onClick (mis. InfoCard),
      // jadi kliknya ditahan agar tidak ikut memicu aksi kartu.
      onClick={(e) => e.stopPropagation()}
    />
    <UncontrolledTooltip
      target={id}
      placement={placement}
      innerClassName="info-tooltip-inner"
    >
      {text}
    </UncontrolledTooltip>
  </>
);

export default InfoTooltip;
